import { SLOTS } from './slots.js'

// Point sources — ways members earn points. Active is an in-table toggle (the
// canonical way an on/off state renders); pages pass onToggle.
export default {
  key: 'point_source',
  label: 'Point Source',
  icon: 'point_sources',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.STATUS, field: 'active', label: 'Active', renderer: 'toggle' },
    { slot: SLOTS.METADATA, field: 'points', label: 'Points', renderer: 'points', unit: 'pts', align: 'right' }
  ],
  empty: { icon: 'point_sources', message: 'No point sources found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.METADATA] }
}
